import React, { useEffect, useRef } from 'react';
import moment from 'moment';
import { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux';

import axios from 'axios';

import { useNavigate } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import { selectToken } from '../utility/Redux/security';
import { selectPrefix } from '../utility/Redux/profile';
import {
  selectCustomerMasterHelpModStatus,
  setCustomerMasterHelpModStatus,
  setModCustomerMasterModifyStatus,
  setSessionExpired,
  setSpinnerLoading,
} from '../utility/Redux/modal';
import { FormatNumber2 } from '../utility/component/tools';
import { CollectionFromToDate } from '../utility/component/collectionFromToDate';
import { CollectionFromToDateMobile } from '../utility/component/collectionFromToDateMobile';
import CustomerMasterhelp from '../help/customermasterHelp';
import PrintItemWiseBooking from './printItemWiseBooking';
import { CallAPIPromise } from '../utility/func/func';

const width = window.innerWidth / 100;

const ItemWiseBookings = () => {
  const token = useSelector(selectToken);
  const prefix = useSelector(selectPrefix);
  const dispatch = useDispatch();
  const [firstDate, setFirstDate] = useState(moment().format('YYYY-MM-DD'));
  const [SecondDate, setSecondDate] = useState(moment().format('YYYY-MM-DD'));
  const [list, setList] = useState([]);
  const [bookingRows, setBookingRows] = useState([]);
  const [detailList, setDetailList] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [bookingCustomerDetails, setBookingCustomerDetails] = useState({
    code: '',
    customer_name: '',
    mobile: '',
    mobile_2: '',
    mobile_3: '',
    phone: '',
    email: '',
    address: '',
    city: '',
    state: '',
    country: '',
    pin_code: '',
    credit_limit: 100000,
    company_name: '',
    company_phone: '',
    company_email: '',
    company_address: '',
    company_city: '',
    company_state: '',
    company_country: '',
    company_pincode: '',
    regd_no1: '',
    regd_no2: '',
    regd_no3: '',
    status: 'Good',
    remarks: '',
  });

  const customerMasterModalStatus = useSelector(
    selectCustomerMasterHelpModStatus
  );

  const customerDetails = (params) => {
    setBookingCustomerDetails(params.row);
    dispatch(setCustomerMasterHelpModStatus(false));
  };

  const columns = [
    {
      field: 'ICODE',
      accessor: 'ICODE',
      type: 'number',

      width: 80,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Code'}
        </div>
      ),
    },
    {
      field: 'ITEM_NAME',
      accessor: 'ITEM_NAME',
      type: 'string',
      flex: 1,
      minWidth: 150,
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Item Name'}
        </div>
      ),
    },

    {
      field: 'QNTY',
      accessor: 'QNTY',
      type: 'string',
      width: 90,
      align: 'right',
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Qnty'}
        </div>
      ),
    },
  ];

  const detailColumns = [
    {
      field: 'DATE',
      headerName: 'Date',
      width: 120,
      headerAlign: 'center',
      align: 'center',
      valueFormatter: ({ value }) =>
        value ? moment(value).format('DD-MM-YYYY') : '',
    },
    {
      field: 'BOOKING_ORDER_NO',
      headerName: 'Booking Order',
      width: 135,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'CUSTOMER_NAME',
      headerName: 'Customer Name',
      minWidth: 190,
      flex: 1,
      headerAlign: 'center',
    },
    {
      field: 'MOBILE',
      headerName: 'Mobile',
      width: 135,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'QNTY',
      headerName: 'Qnty',
      width: 85,
      headerAlign: 'center',
      align: 'right',
    },
    {
      field: 'TRY_DATE',
      headerName: 'Trial Date',
      width: 120,
      headerAlign: 'center',
      align: 'center',
      valueFormatter: ({ value }) =>
        value ? moment(value).format('DD-MM-YYYY') : '',
    },
    {
      field: 'DEL_DATE',
      headerName: 'Delivery Date',
      width: 125,
      headerAlign: 'center',
      align: 'center',
      valueFormatter: ({ value }) =>
        value ? moment(value).format('DD-MM-YYYY') : '',
    },
  ];
console.log(bookingRows)
console.log(list)
  const selectItem = (row) => {
    const hasItemCode = bookingRows.some(
      (booking) => booking.ICODE !== undefined && booking.ICODE !== null
    );
    const matchingRows = bookingRows.filter((booking) =>
      hasItemCode
        ? String(booking.ICODE) === String(row.ICODE)
        : booking.ITEM_NAME === row.ITEM_NAME
    );

    setSelectedItem(row);
    setDetailList(
      matchingRows.map((booking, index) => ({
        ...booking,
        id: `${row.ICODE}-${booking.BOOKING_ORDER_NO || 'booking'}-${index}`,
      }))
    );
  };

  const loadVocherAPI = (invNo) => {
    const data = {
      table_prefix: prefix,
      FDATE: firstDate,
      TDATE: SecondDate,
    };

    dispatch(setSpinnerLoading('Loading'));
    CallAPIPromise(`/api/reportRoute/ItemWiseBookings`, data)
      .then(async function (summaryResponse) {
        if (!summaryResponse.data.error) {
          const responseData = summaryResponse.data.response;
          console.log(
            'ITEM_WISE_SUMMARY_SAMPLE',
            JSON.stringify(responseData?.[0] || {})
          );
          const l = responseData.map((e, i) => {
            return {
              ...e,
              id: i,
            };
          });
          setList(l);
        }
        setSelectedItem(null);
        setDetailList([]);
        return CallAPIPromise(`/api/reportRoute/bookingReport`, {
          ...data,
          MOBILE: '',
        });
      })
      .then((detailResponse) => {
        if (!detailResponse.data.error) {
          console.log(
            'ITEM_WISE_DETAIL_SAMPLE',
            JSON.stringify(detailResponse.data.response?.[0] || {})
          );
          setBookingRows(detailResponse.data.response || []);
        }
      })
      .catch(function (error) {
        if (error.response.data.name === 'TokenExpiredError') {
          dispatch(setSessionExpired(true));
        }
        console.log(error);
      })
      .finally(() => {
        dispatch(setSpinnerLoading(false));
      });
  };

  const printRef = useRef();
  const navigate = useNavigate();
  const thermalPrintRef = useRef();
  const [selectedPrintOption, setSelectedPrintOption] = useState('print');
  const [windowSize, setWindowSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowSize(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowSize <= 800;
  const totalQuantity = list.reduce(
    (total, row) => total + (Number(row.QNTY) || 0),
    0
  );
  const tableHeight = Math.min(380, Math.max(210, 112 + list.length * 42));
  const detailTableHeight = Math.min(
    380,
    Math.max(210, 112 + detailList.length * 42)
  );
  const dataGridSx = {
    height: '100%',
    width: '100%',
    minWidth: 0,
    borderRadius: '6px',
    backgroundColor: 'white',
    border: '1px solid #eadbd4',
    fontSize: 14,
    '& .MuiDataGrid-columnHeaders': {
      backgroundColor: '#f8e4dc',
      color: '#383535',
      borderBottom: '2px solid #f5874f',
    },
    '& .MuiDataGrid-columnHeader': {
      backgroundColor: '#f8e4dc',
      borderRight: '1px solid #eadbd4',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      fontWeight: 700,
      fontSize: '12px',
      letterSpacing: '0.025em',
    },
    '& .super-app-theme--header': { backgroundColor: '#f8e4dc' },
    '& .MuiDataGrid-cell': {
      borderRight: '1px solid #f0e3dd',
      borderBottom: '1px solid #f5ebe6',
      color: '#4b4545',
    },
    '& .MuiDataGrid-row:hover': { backgroundColor: '#fff2eb' },
    '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#fffaf7' },
    '& .MuiDataGrid-row.Mui-selected, & .MuiDataGrid-row.Mui-selected:hover': {
      backgroundColor: '#fde5d8',
    },
    '& .MuiDataGrid-footerContainer': {
      borderTop: '1px solid #eadbd4',
      color: '#6b6260',
    },
    '& .MuiDataGrid-virtualScroller': {
      overflowX: 'auto',
      overflowY: 'auto',
      overscrollBehavior: 'contain',
    },
  };

  const handlePrint = useReactToPrint({
    content: () =>
      selectedPrintOption === 'print'
        ? printRef.current
        : thermalPrintRef.current,
    pageStyle: `
      @page { size: A4 landscape; margin: 10mm; }
      @media print {
        body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      }
    `,
    onAfterPrint: () => {
      navigate('/item_wise_booking');
      setSelectedPrintOption('print');
    },
  });

  return (
    <div
      className={`flex h-full min-h-0 min-w-0 w-full flex-col overflow-x-hidden bg-[#fff9f6] p-3 ${
        isMobile ? 'overflow-y-auto' : 'overflow-y-hidden'
      }`}
    >
      {isMobile ? (
        <div className="min-w-0 shrink-0">
          <CollectionFromToDateMobile
            setFirstDate={setFirstDate}
            firstDate={firstDate}
            SecondDate={SecondDate}
            hideCustomer={true}
            setSecondDate={setSecondDate}
            onOkClick={loadVocherAPI}
            printButton={
              <button
                type="button"
                onClick={handlePrint}
                disabled={!list.length}
                className="flex h-[30px] items-center justify-center gap-2 rounded-md border border-[#f5874f] px-4 text-sm font-semibold text-[#f5874f] disabled:cursor-not-allowed disabled:opacity-45"
              >
                <i className="bi bi-printer"></i>
                Print
              </button>
            }
            reset={() => {
              setBookingCustomerDetails({ customer_name: '', mobile: '' });
            }}
            bookingCustomerDetails={bookingCustomerDetails}
          />
        </div>
      ) : (
        <div className="min-w-0 shrink-0">
          <CollectionFromToDate
            setFirstDate={setFirstDate}
            firstDate={firstDate}
            SecondDate={SecondDate}
            hideCustomer={true}
            setSecondDate={setSecondDate}
            onOkClick={loadVocherAPI}
            printButton={
              <button
                type="button"
                onClick={handlePrint}
                disabled={!list.length}
                className="flex h-12 items-center justify-center gap-2 rounded-md border border-[#f5874f] px-5 text-sm font-semibold text-[#f5874f] transition hover:bg-[#fff2eb] disabled:cursor-not-allowed disabled:opacity-45"
              >
                <i className="bi bi-printer"></i>
                Print
              </button>
            }
            reset={() => {
              setBookingCustomerDetails({ customer_name: '', mobile: '' });
            }}
            bookingCustomerDetails={bookingCustomerDetails}
            reportLayout
          />
        </div>
      )}

      <div
        className={`mt-3 grid min-h-0 min-w-0 gap-3 max-sm:mt-2 ${
          isMobile
            ? 'shrink-0 grid-cols-1'
            : 'flex-1 grid-cols-[minmax(320px,0.38fr)_minmax(0,1fr)]'
        }`}
      >
        <div className="flex min-h-0 min-w-0 flex-col">
          <div className="mb-2 flex h-7 shrink-0 items-center justify-between px-1">
            <div className="text-sm font-bold text-[#4b4545]">Item Summary</div>
            <div className="text-xs text-[#8b7f7a]">Select an item</div>
          </div>
          <div
            className={`min-h-[180px] min-w-0 overflow-hidden ${
              isMobile ? 'shrink-0' : 'flex-1'
            }`}
            style={isMobile ? { height: tableHeight } : undefined}
          >
            <DataGrid
              sx={dataGridSx}
              rowHeight={42}
              headerHeight={46}
              columns={columns}
              rows={list}
              hideFooter
              scrollbarSize={8}
              rowsPerPageOptions={[100]}
              onRowClick={(params) => selectItem(params.row)}
              selectionModel={selectedItem ? [selectedItem.id] : []}
              experimentalFeatures={{ newEditingApi: true }}
              showCellRightBorder={true}
              showColumnRightBorder={true}
              disableColumnSelector
              disableColumnReorder
              disableColumnMenu={true}
              components={{
                NoRowsOverlay: () => (
                  <div className="flex h-full w-full flex-col items-center justify-center text-ggray">
                    <i className="bi bi-box-seam mb-2 text-2xl opacity-60"></i>
                    <span className="font-medium">No item bookings found</span>
                    <span className="mt-1 text-xs">
                      Change the date range and apply the filter.
                    </span>
                  </div>
                ),
              }}
            />
          </div>
          <div className="mt-2 grid min-h-[44px] shrink-0 grid-cols-[80px_minmax(120px,1fr)_90px] rounded-md border border-[#eadbd4] bg-white text-sm">
            <div className="border-r border-[#f0e3dd]"></div>
            <div className="flex items-center justify-end border-r border-[#f0e3dd] px-4 text-xs font-bold text-[#514946]">
              Total Quantity
            </div>
            <div className="flex items-center justify-end px-4 font-bold text-[#7f3048]">
              {totalQuantity}
            </div>
          </div>
        </div>

        <div className="flex min-h-0 min-w-0 flex-col">
          <div className="mb-2 flex h-7 shrink-0 items-center justify-between px-1">
            <div className="min-w-0 truncate text-sm font-bold text-[#4b4545]">
              Booking Details
              {selectedItem ? ` — ${selectedItem.ITEM_NAME}` : ''}
            </div>
            <div className="shrink-0 text-xs text-[#8b7f7a]">
              {selectedItem
                ? `${detailList.length} booking${detailList.length === 1 ? '' : 's'}`
                : 'No item selected'}
            </div>
          </div>
          <div
            className={`min-h-[180px] min-w-0 overflow-hidden ${
              isMobile ? 'shrink-0' : 'flex-1'
            }`}
            style={isMobile ? { height: detailTableHeight } : undefined}
          >
            <DataGrid
              sx={dataGridSx}
              rowHeight={42}
              headerHeight={46}
              columns={detailColumns}
              rows={detailList}
              hideFooter
              scrollbarSize={8}
              rowsPerPageOptions={[100]}
              experimentalFeatures={{ newEditingApi: true }}
              showCellRightBorder={true}
              showColumnRightBorder={true}
              disableColumnSelector
              disableColumnReorder
              disableColumnMenu={true}
              components={{
                NoRowsOverlay: () => (
                  <div className="flex h-full w-full flex-col items-center justify-center text-ggray">
                    <i className="bi bi-table mb-2 text-2xl opacity-60"></i>
                    <span className="font-medium">
                      {selectedItem
                        ? 'No booking details found'
                        : 'Select an item to view bookings'}
                    </span>
                  </div>
                ),
              }}
            />
          </div>
          <div className="mt-2 flex min-h-[44px] shrink-0 items-center justify-end rounded-md border border-[#eadbd4] bg-white px-4 text-sm">
            <span className="mr-3 text-xs font-bold text-[#514946]">
              Detail Quantity
            </span>
            <span className="font-bold text-[#7f3048]">
              {detailList.reduce(
                (total, row) => total + (Number(row.QNTY) || 0),
                0
              )}
            </span>
          </div>
        </div>
      </div>

      <CustomerMasterhelp
        onRowClick={(params) => {
          if (customerMasterModalStatus) {
            customerDetails(params);
          }
          dispatch(setModCustomerMasterModifyStatus(false));
        }}
      />

      <div className="hidden">
        {selectedPrintOption === 'print' && windowSize ? (
          <div
            ref={printRef}
            style={{ display: 'block', visibility: 'hidden' }}
          >
            <PrintItemWiseBooking
              data={list}
              details={detailList}
              selectedItem={selectedItem}
              firstDate={firstDate}
              SecondDate={SecondDate}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ItemWiseBookings;
